<!--

园区管理界面

-->
<template>
  <div>
    <el-row :gutter="10">
      <el-col :span="10">
        <el-table :data="parks" height="500">
          <!-- 第一列 -->
          <el-table-column>
            <!--            <template slot="header">-->
            <!--              {{ currentEnterprise.name }} 的下属园区-->
            <!--            </template>-->
            <template slot-scope="scope">
              <!-- 如果是新增的一行 -->
              <!-- <template v-if="scope.row.transient">
                <el-input
                  size="small"
                  placeholder="新园区，在这里填写园区名称"
                  v-model="scope.row.name"
                  maxlength="30"
                ></el-input>
              </template> -->
              <el-dialog
                v-if="scope.row.transient"
                title="新增园区"
                :visible.sync="scope.row.transient"
                width="50%"
              >
                <el-input
                  size="small"
                  placeholder="新园区，在这里填写园区名称"
                  v-model="scope.row.name"
                  maxlength="30"
                ></el-input>
                <div
                  slot="footer"
                  class="dialog-footer"
                  style="text-align: center"
                >
                  <el-button @click="cancel">取 消</el-button>
                  <el-button type="primary" @click="addSubmit(scope.row)"
                    >确 定</el-button
                  >
                </div>
              </el-dialog>
              <!-- 否则是已有的一行数据 -->
              <span v-else>
                <!-- 如果正处于编辑状态 -->
                <span v-if="scope.row.editing">
                      <el-dialog
                    v-if="scope.row.editing"
                    title="编辑园区"
                    :visible.sync="dialogShow"
                    width="50%"
                  >
                    <el-input
                      size="small"
                      placeholder="新园区，在这里填写园区名称"
                      v-model="scope.row.name"
                      maxlength="30"
                    ></el-input>
                    <div
                      slot="footer"
                      class="dialog-footer"
                      style="text-align: center"
                    >
                      <el-button @click="close(scope.row)">取 消</el-button>
                      <el-button type="primary" @click="editSubmit(scope.row)"
                        >确 定</el-button
                      >
                    </div>
                  </el-dialog>
                  <!-- <el-input v-model="scope.row.name" maxlength="30"></el-input> -->
                </span>
                <!-- 否则处于显示状态 -->
                <span v-else>{{ scope.row.name }}</span>
              </span>
            </template>
          </el-table-column>
          <!-- 第二列 -->
          <el-table-column width="150px">
            <template slot="header">
              <!-- 标题上显示一个新增启动按钮 -->
              <el-tooltip
                class="item"
                effect="dark"
                content="新增"
                placement="top"
              >
                <el-button
                  size="mini"
                  type="primary"
                  circle
                  icon="el-icon-plus"
                  @click="addStart"
                />
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <!-- 如果是新增的一行，显示保存按钮和取消按钮 -->
              <div v-if="scope.row.transient">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="提交"
                  placement="top"
                >
                  <el-button
                    size="mini"
                    type="success"
                    circle
                    icon="el-icon-check"
                    @click="addSubmit(scope.row)"
                  />
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="删除"
                  placement="top"
                >
                  <el-button
                    size="mini"
                    type="danger"
                    circle
                    icon="el-icon-delete"
                    @click="cancel(scope.row, scope.$index)"
                  />
                </el-tooltip>
              </div>
              <!-- 否则是已有的行，可能处于编辑或非编辑状态 -->
              <div v-else>
                <!-- 编辑状态，显示一个保存按钮和一个放弃按钮 -->
                <template v-if="scope.row.editing">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="提交"
                    placement="top"
                  >
                    <el-button
                      size="mini"
                      type="success"
                      circle
                      icon="el-icon-check"
                      @click="editSubmit(scope.row)"
                    />
                  </el-tooltip>
                </template>
                <!-- 非编辑状态，显示一个启动编辑的按钮 -->
                <el-tooltip
                  v-else
                  class="item"
                  effect="dark"
                  content="编辑"
                  placement="top"
                >
                  <el-button
                    size="mini"
                    type="warning"
                    circle
                    icon="el-icon-edit"
                    @click="editStart(scope.row)"
                  />
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="删除"
                  placement="top"
                >
                  <el-button
                    v-if="!scope.row.editing"
                    size="mini"
                    type="danger"
                    circle
                    icon="el-icon-delete"
                    @click="del(scope.row,scope.$index)"
                  />
                </el-tooltip>
                 <el-tooltip class="item" effect="dark" content="定位" placement="top">
                      <el-button
                        v-if="!scope.row.editing"
                        size="mini"
                        icon="el-icon-delete-location"
                        type="warning"
                        circle

                        @click="$router.push(`park/locate/${scope.row.id}`)"
                      />
                    </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 12px; text-align: center">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="value"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </el-col>
      <el-col :span="14">
        <el-row>

    </el-row>
        <div
          id="mapDiv"
          style="
            height: 580px;
            background-color: #f3f3f3;
            text-align: center;
            line-height: 580px;
          "
        >
        <el-button type="primary"  :disabled = "btnStatus" @click="showMap">显示地图</el-button>
          <!-- 地图显示（拥有多家主体的用户，显示多家，突出显示当前） -->
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import map from './map.js'
import { parkSearch, parkAdd, parkUpdate, parkDelete } from '@/api/park.js'

export default {
  name: 'Park',
  data() {
    return {
      pageNum: 1,
      value: 10,
      total: 0,
      parks: [],
      dialogShow:false,
      enterPriseId: this.$store.getters.currentEnterprise.id,
      /**
       * 正在编辑中的园区条目
       */
      editing: undefined,
      btnStatus:true
    }
  },
  computed: {
    currentEnterprise() {
      return this.$store.getters.currentEnterprise
    },
  },
  mounted() {
    //  map.init('mapDiv', enterprises)
    this.parkDateGet()



  },
  methods: {
    handleSizeChange(val) {
      this.value = val
      this.pageNum = 1
      this.parkDateGet()
      console.log(`每页 ${val} 条`)
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.parkDateGet()
      console.log(`当前页: ${val}`)
    },
    del(row, index) {
      console.log(row)
      parkDelete({ id: row.id }).then((data) => {
        this.parks.splice(index, 1)
      })
    },
    cancel(row, index) {
      console.log(index)
      this.parks.splice(index, 1)
    },
    close(row){
      row.name=row.nameTransient
      row.editing=false
      this.dialogShow=false
    },
    parkDateGet() {
      this.enterpriseId = this.$store.getters.currentEnterprise.id
      let option = {
        pageNum: this.pageNum,
        pageSize: this.value,
        enterpriseId: this.enterpriseId,
        name: null,
      }
      console.log('option', option)
      parkSearch(option).then((data) => {
        this.parks = data.data.list
        this.total = data.data.total
        if(this.parks){
           this.btnStatus = false
        }

      })
    },
    addSubmit(row) {
      if (row.name) {
        row.enterpriseId = this.enterPriseId
        parkAdd(row).then((data) => {
          row.transient = false
          row.editing = false
          this.parkDateGet()
        })
      } else {
        this.$message.error('园区名称不能为空')
      }
    },
    addStart() {
      const { parks } = this
      // if (parks[0].transient) {
      //   return
      // }
      this.parks.unshift({ transient: true, parkName: '' })
    },
    editStart(item) {
         this.dialogShow=true
      // 把名称拷贝到一个临时字段，修改的输入框绑定该临时字段，以免影响原始数据
      this.$set(item, 'nameTransient', item.name)
      //  把之前已经处于编辑状态的数据行取消编辑状态
      this.parks.forEach((p) => {
        if (p.editing) {
          this.$set(p, 'editing', false)
        }
      })
      // 把数据设置为编辑状态
      this.$set(item, 'editing', true)
    },
    editSubmit(item) {
      let id = item.id
      item.enterPriseId = this.enterPriseId
      parkUpdate(id, item).then((data) => {
        item.editing = false
        item.transient = false
        console.log(data)
      })
    },
    showMap(){
           map.init('mapDiv',true,this.parks )
    }
  },
   beforeDestroy() {
    map.destroy()
    console.log('【↓↓↓】', this.$options.name)
  },
}
</script>



// WEBPACK FOOTER //
// src/components/meta/park/Index.vue